<template>
  <div>
    <vue-headful title="aanbevolen" />
    <Header page_title="aanbevolen" />
    <div v-if="matches && matches.length > 0">
      <div class="px-4 mx-2 pb-5">
        <div class="container-fluid px-0 pb-4 mb-3">
          <div class="clearfix mb-3">
            <div class="float-left w-75">
              <p class="mb-0">
                <strong>
                  {{ matches.length }} aanbevolen vacature{{
                    matches.length > 1 ? "s" : ""
                  }}
                </strong>
              </p>
            </div>
            <button
              type="button"
              class="btn-filter position-relative p-0 m-0 float-right"
            >
              Filter
              <div class="icon-wrapper d-inline-block">
                <i class="material-icons-round">filter_list</i>
              </div>
            </button>
          </div>
          <div class="mb-4">
            <JobCard
              v-for="job in matches"
              :key="job.id"
              :job="job"
              :recommended="true"
            />
          </div>
        </div>
      </div>
      <footer class="bg-white fixed-btn position-fixed w-100">
        <div class="px-4 mx-2">
          <div class="container-fluid px-0">
            <a
              role="button"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
              >Filter vacatures</a
            >
          </div>
        </div>
      </footer>
    </div>
    <Empty v-else text="You don't have any recommended jobs." />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";

export default {
  data: function() {
    return {
      matches: null,
      pending: [
        {
          id: "1",
          location: "Amsterdam",
          title: "Leerkracht groep 6 gezocht voor Daltononderwijs",
          date: "17 maart 2019",
          percentage: 80,
          view: true
        }
      ]
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.matches = await this.getTokenAPIList("recommended");
      this.$store.state.loading = false;
    }
  },
  components: {
    JobCard
  }
};
</script>

<style scoped></style>
